<template>
  <div>
    <div class="landscape">
      <div class="corridor">
        <transition name="fade">
          <div class="todojo glowing-mobile" v-show="isMobile"></div>
        </transition>
        <transition name="fade">
          <div class="todojo" v-show="todojo"></div>
        </transition>
        <router-link to="/dojo">
          <div
            class="dojo"
            :class="{ cursorLeft: todojo }"
            @mouseover="
              todojo = true;
              $store.commit('setToPlace', 'to_dojo');
            "
            @mouseleave="
              todojo = false;
              $store.commit('setToPlace', '...');
            "
          ></div>
        </router-link>
        <Portal></Portal>
      </div>
    </div>
    <div class="portrait">
      <NotOriented></NotOriented>
    </div>
  </div>
</template>

<script>
import Portal from "./Portal";
import MainMixin from "@/components/utilities/MainMixin.vue";
import NotOriented from "@/components/mobile/NotOriented";
export default {
  name: "Corridor",
  title: "To Dojo",
  components: {
    Portal,
    NotOriented,
  },
  mixins: [MainMixin],
  mounted() {
    this.init();
  },
  data() {
    return {
      todojo: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.corridor {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/corridor.png");
  background-size: 100vw 100vh;
}

.dojo {
  position: absolute;
  top: 33vh;
  height: 40vh;
  width: 21vw;
  left: 38vw;
}

.todojo {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/torealdojo.jpg");
  background-size: 100vw 100vh;
}
</style>
